import * as d3 from 'd3'
export default {
  methods: {

    draw_Summary() {

      let canvasSummary = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.summary.x}, ${this.summary.y})`)

      if(this.summary.type == 'progress') this.sum_Progress(canvasSummary)
      if(this.summary.type == 'procurement') this.sum_Procurement(canvasSummary)

    },


    sum_Progress(selection) {

      selection
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', 4)
      .attr('width', this.summary.width).attr('height', 8)
      .attr('fill', '#E0E0DF').attr('stroke-width', 0)
      .attr('opacity', .75)
   
      selection
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', 4)
      .attr('width', (this.summary.width/100) * this.sumData.PRO).attr('height', 8)
      .attr('fill', '#83D2F5').attr('opacity', .7)

      this.summary.cols.forEach(col=> {

        if(col.code=='PRO') {
          selection // Name
          .append('text')
          .attr('x', col.sx).attr('y', -2)
          .attr('fill', '#757575').attr('font-size', 8.5)
          .text(col.name)

          selection // Value
          .append('text')
          .attr('x', col.sx).attr('y', -11)
          .attr('fill', col.tColor).attr('font-size', col.tSize)
          .text(this.sumData[col.code]+'%')
        } else {
          selection // Name
          .append('text')
          .attr('x', col.ex).attr('y', -14)
          .attr('fill', '#757575').attr('font-size', 8.5).attr('text-anchor', 'end')
          .text(col.name)

          selection // Value
          .append('text')
          .attr('id', `STATUS_${col.status}_${this.localId}`)
          .attr('x', col.ex).attr('y', -2)
          .attr('fill', col.tColor).attr('font-size', col.tSize).attr('text-anchor', 'end')
          .attr('font-weight', this.current.status==col.status ? 450 : 400)
          .text(this.sumData[col.code])
          .call(this.call_Progress, col)
        }
      })
    },


    sum_Procurement(selection) {

      selection
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', 4)
      .attr('width', this.summary.width).attr('height', 8)
      .attr('fill', '#E0E0DF').attr('stroke-width', 0)
      .attr('opacity', .75)
   
      selection
      .append('rect')
      .attr('id', `PROG_BAR_${this.localId}`)
      .attr('x', 0).attr('y', 0).attr('rx', 4)
      .attr('width', 0).attr('height', 8)
      .attr('fill', '#83D2F5').attr('opacity', .7)

      this.summary.cols.forEach(col=> {
        let prog = this.sumData[col.code]==0 || col.code == 'TOTAL' ? 0 : (this.summary.width) * (this.sumData[col.code]/this.sumData.TOTAL)

        selection // Name
        .append('text')
        .attr('x', col.ex).attr('y', -15)
        .attr('fill', '#757575').attr('font-size', 9).attr('text-anchor', 'end')
        .text(col.name)

        selection // Value
        .append('text')
        .attr('id', `STATUS_${col.status}_${this.localId}`)
        .attr('x', col.ex).attr('y', -2)
        .attr('fill', col.tColor).attr('font-size', col.tSize).attr('text-anchor', 'end')
        .attr('font-weight', this.current.status==col.status ? 450 : 400)
        .text(this.sumData[col.code])
        .call(this.call_Procurement, col, prog)

      })
    },

  }
}